import React from 'react';
import { createContext } from 'use-context-selector';

export const AuthenticationContext = createContext();
export const Authentication2Context = React.createContext();
